/**
 * GameOver component - end screen
 */

interface GameOverProps {
  score: number;
  level: number;
  highScore: number;
  isNewHighScore: boolean;
  onRestart: () => void;
}

export function GameOver({ score, level, highScore, isNewHighScore, onRestart }: GameOverProps) {
  return (
    <div className="game-menu-overlay">
      <div className="game-menu game-over">
        <h2>
          Game Over!
        </h2>

        {isNewHighScore && (
          <div className="new-high-score" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
            🏆 New High Score! 🏆
          </div>
        )}

        <div className="stats-grid">
          <div className="stat-card">
            <p className="stat-label">Final Score</p>
            <p className="stat-value">{score}</p>
          </div>

          <div className="stat-card">
            <p className="stat-label">Level Reached</p>
            <p className="stat-value" style={{ color: '#3b82f6' }}>{level}</p>
          </div>

          {!isNewHighScore && highScore > 0 && (
            <div className="stat-card" style={{ borderTop: '1px solid #374151', paddingTop: '1rem' }}>
              <span style={{ color: '#9ca3af' }}>🏆 High Score: {highScore}</span>
            </div>
          )}
        </div>

        <button onClick={onRestart}>
          🔄 Play Again
        </button>
      </div>
    </div>
  );
}
